import { render, staticRenderFns } from "./EnvioTemplateAcoes.vue?vue&type=template&id=d918a788&scoped=true&"
import script from "./EnvioTemplateAcoes.vue?vue&type=script&lang=js&"
export * from "./EnvioTemplateAcoes.vue?vue&type=script&lang=js&"
import style0 from "./EnvioTemplateAcoes.vue?vue&type=style&index=0&id=d918a788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d918a788",
  null
  
)

export default component.exports